export const testResultsEN = {
    "topLabel": "Enter tests and results from labs below. Tests from Ambry Genetics can be synced.",
    "negative": "Negative",
    "delete": "Delete",
    "testDetails": "Test Details",
    "seeDetails": "See Details...",
    "gene": "Gene",
    "variant": "Variant",
    "classification": "Classification",
    "priorClassification": "Prior Classification",
    "addRow": "Add Row",
    "deleteRow": "Delete Row",
    "geneCount": "Gene Count",
    "cancel": "Cancel",
    "save": "Save",
    "other": "Other",
    "singleSite": "Single-Site",
    "documents": "Documents",
    "actions": "Actions",
    "lab": "Lab",
    "test": "Test",
    "submittedDate": "Submitted Date",
    "reportedDate": "Reported Date",
    "reclassDate": "Reclass Date",
    "status": "Status",
    "result": "Result",
    "document": "Document",
    "notes": "Notes",
    "Delete Test": "Delete Test",
    "Delete Document": "Delete Document",
    "Ambry Orders - Setup": "Ambry Orders - Setup",
    "Multiple Reports": "Multiple Reports",
    "deleteTestConfirm": "Are you sure you want to delete this test?",
    "deleteDocConfirm": "Are you sure you want to delete this document?",
    "ambryKeysMessage": "This feature enables you to order diagnostic testing directly from the Progeny interface, and digitally and securely pass your patient and pedigree information to Ambry Genetics. The test results will also be synced automatically back into Progeny. <br/> <br/>  A one-time setup is required to sign up with Ambry Genetics and securely authorize transmission to this service. Please contact Progeny Support to initiate this process.   <br/> <br/>  By clicking the link below, you will be passed out of the Progeny application and over to the Progeny Support website.   <br/> <br/>  <a target='_blank' href='http://www.progenygenetics.com/support/ambryorder'>Contact Progeny Support -  <br/>   http://www.progenygenetics.com/support/ambryorder</a>",
    "multipleReportsMessage": "There are multiple reports for this person. Please view the attached reports, then verify and manually update the results in the window appropriately.",
    "Delete": "Delete",
    "Cancel": "Cancel",
    "Close": "Close",
    "Pathogenic": "Pathogenic",
    "Likely Pathogenic": "Likely Pathogenic",
    "VUS": "VUS",
    "Likely Benign": "Likely Benign",
    "Negative": "Negative",
    "In Progress": "In Progress",
    "Reported": "Reported",
    "Cancelled": "Cancelled",
    "viewTestDetails": "View Test Details",
    "deleteTest": "Delete Test",
    "testResultsFor": "Test Results for ",
    "newTest": "New Test",
    "noResults": "There are no test results to display.",
    "wrongData": "Data for test results loaded incorrectly. Please close and open test results again.",
    "serverError": "Server error",
    "blacklistFilesErrorMessage": "You may not upload files of this type",
    "otherLab": "Other Lab",
    "otherTest": "Other Test",
    "Must not exceed 100 characters": "Must not exceed 100 characters",
    "Must not exceed 50 characters": "Must not exceed 50 characters",
    "New Custom Panel": "New Custom Panel",
    'Create': 'Create',
    'Failed to save folder': 'Failed to save folder',
    'Add New Custom Panel': 'Add New Custom Panel',
    'Name': 'Name',
    'Failed to get folders': 'Failed to get folders',
    'Delete Panel': 'Delete Panel',
    'Custom Test Name': 'Custom Test Name',
    'Failed to get labs': 'Failed to get labs',
    'Save As': 'Save As',
    'The field is required': 'The field is required',
    'Load Custom Panel': 'Load Custom Panel',
    'Load': 'Load',
    'Failed to get panel format': 'Failed to get panel format',
    'Failed to create panel': 'Failed to create panel',
    'Failed to update panel': 'Failed to update panel',
    'Failed to load format': 'Failed to load format',
    'Failed to create folder': 'Failed to create folder',
    'Custom Panel Details': 'Custom Panel Details',
    'Save As Custom Panel': 'Save As Custom Panel',
    'OK': 'OK',
    'Folder name already exists': 'Folder name already exists',
    'Format name already exists': 'Format name already exists',
    Requires: 'Requires',
    format: 'format',
    'Failed to check panel name': 'Failed to check panel name',
    'existingCustomPanel': 'This name has already been used, would you like to overwrite the current format being used by this name?',
    'Overwrite': 'Overwrite',
    'Failed to check test name': 'Failed to check test name',
    'Test name already exists': 'Test name already exists',
    'Panel name already exists': 'Panel name already exists',
};